import { useRef } from "react";

import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

import { SearchFilteredRecipesInterface } from "../../app/search/search.types";
import { SOURCE } from "../newHomePage/utils/constants";
import RecipeCard from "../recipeCard";
import styles from "./listView.module.css";

const RenderSkeletons = () => (
  <Grid className={styles.skeleton_wrapper} id="skeleton-loader-wrapper-listview">
    {Array(12).fill(null).map((index) => <Skeleton className={styles.skeleton_card} id={`skeleton-card-${index}`} variant="rectangular"
    />)}
  </Grid>
);

const getClassName = (recipes: SearchFilteredRecipesInterface[]) => {
  const cardWidth = 176;
  const containerWidth = window ? window.innerWidth : 0;
  const cardsPerRow = Math.floor(containerWidth / cardWidth);
  const alignmentClass = cardsPerRow > 0 && cardsPerRow < recipes.length ? styles.center_align : styles.left_align;
  return alignmentClass; 
}

const ListView = ({
  recipes,
  loading = false,
}: {
  recipes: SearchFilteredRecipesInterface[];
  loading?: boolean;
}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  return (
    <Grid
      className={`${styles.wrapper} ${!loading ? getClassName(recipes) : ''}`}
      id="recipe-card-wrapper"
      ref={wrapperRef}
    >
      {loading ? <RenderSkeletons /> : null}
      {!loading &&
        recipes.map((recipe: SearchFilteredRecipesInterface) => (
          <Grid className={styles.recipe_wrapper} key={recipe?.id}>
            <RecipeCard recipe={recipe} source={SOURCE.LISTVIEW} />
          </Grid>
        ))}
    </Grid>
  );
};

export default ListView;
